/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeadsetOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m23.707 22.293-1.414 1.414-.707-.707H15v-6.586L5.268 6.682A7.953 7.953 0 0 0 4 11v7h2v-2h7v6H6v-2H2v-9c0-2.142.677-4.13 1.828-5.758L.293 1.707 1.707.293zM17 18.413V21h2.586zM11 18H8v2h3zm1-17c5.514 0 10 4.486 10 10v6.586L18.414 14H20v-3c0-4.411-3.589-8-8-8a7.95 7.95 0 0 0-3.685.9L6.846 2.434A9.94 9.94 0 0 1 12 1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgHeadsetOff as HeadsetOff };
